'use strict';

export default function () {
  initConditionalFormFields();
}

function initConditionalFormFields () {
  const conditionalFields = document.querySelectorAll('fieldset.fieldset-conditional');

  Array.prototype.forEach.call(conditionalFields, function (field) {
    createConditionalWatchers(field);
  });
}

function createConditionalWatchers (field) {
  const conditions = getConditions(field);
  conditions.forEach(function (condition) {
    addInputListeners(condition);
  });
}

function addInputListeners (condition) {
  const inputs = document.querySelectorAll('input[name^="' + condition.fieldName + '"]');
  Array.prototype.forEach.call(inputs, function (input) {
    if (input.type === 'radio' || input.type === 'checkbox') {
      toggleConditionalField(condition, input.checked && condition.fieldValues.indexOf(input.value.trim()) > -1);
    } else {
      toggleConditionalField(condition, condition.fieldValues.indexOf(input.value.trim()) > -1);
    }

    input.addEventListener('change', function (event) {
      if (input.type === 'radio' || input.type === 'checkbox') {
        toggleConditionalField(condition, input.checked && condition.fieldValues.indexOf(event.target.value.trim()) > -1);
      } else {
        toggleConditionalField(condition, condition.fieldValues.indexOf(event.target.value.trim()) > -1);
      }
    });
  });
}

function getConditions (field) {
  if (!field || !field.dataset || !field.dataset.enableFor) {
    return [];
  }

  return field.dataset.enableFor
    .split(',')
    .filter(function (cond) {
      return cond && cond.split(':').length === 2;
    })
    .map(function (cond) {
      const result = cond.split(':');
      const fieldName = result[0];
      const fieldValue = result[1];
      return {
        field: field,
        fieldName: fieldName,
        fieldValue: fieldValue,
      };
    })
    .reduce(function (r, el) {
      const item = r.find(function (element) {
        return element.fieldName === el.fieldName;
      });

      if (!item) {
        r.push({
          field: el.field,
          fieldName: el.fieldName,
          fieldValues: [el.fieldValue],
        });
      } else {
        item.fieldValues.push(el.fieldValue);
      }

      return r;
    }, []);
}

function toggleConditionalField (condition, toggle) {
  if (toggle) {
    condition.field.style.display = 'block';
    condition.field.removeAttribute('disabled');
  } else {
    if (isAnyConditionMet(condition.field)) {
      return;
    }

    condition.field.style.display = 'none';
    condition.field.setAttribute('disabled', 'disabled');
  }
}

function isAnyConditionMet (field) {
  let result = false;
  const conditions = getConditions(field);

  conditions.forEach(function (condition) {
    const inputs = document.querySelectorAll('input[name^="' + condition.fieldName + '"]');
    Array.prototype.forEach.call(inputs, function (input) {
      const value = input.value.trim();

      if (input.type === 'radio' || input.type === 'checkbox') {
        if (input.checked && condition.fieldValues.indexOf(value) > -1) {
          result = true;
        }
      } else {
        if (condition.fieldValues.indexOf(value) > -1) {
          result = true;
        }
      }
    });
  });

  return result;
}
